module.exports = __webpack_public_path__ + "static/media/pets.05e647bb.png";